import request from '@/utils/request'
import baseUrl from '@/api/baseUrl'
export default { 
	login( username , password, login_type ) {
		return request({
			url: baseUrl + '/auth/login',
			method: 'post',
			data: {
				username,
				password,
				login_type
			}
		})
	},
	getUserInfo(){
		return request({
			url: baseUrl + '/system/admin/profile',
			method: 'get'
		})
	},
	/**
	 * 语言设置
	**/
    setLang(id, data) {
		return request({
			url: baseUrl + '/system/setLang/'+id,
			method: 'POST',
			data
		})
	}
}